import { TabCombinedProps } from './types';

const usePresenter = (props: TabCombinedProps): TabCombinedProps => {
  return props;
};

export default usePresenter;
